import React from 'react'
import styled from 'styled-components'
import { Section } from 'fbk-components'
import { TitleWithBorder, NewsItem, Button } from 'components'
import { NewsData } from 'types'
import { spacings } from 'theme'

interface NewsItem {
  date: string
  title: string
  text: string
}

const Wrapper = styled(Section)`
  ${spacings('padding-bottom', 'xl')}

  @media (min-width: 768px) {
    ${Button} {
      width: calc(50% - 20px);
    }

    .news-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
`

interface Props {
  data: NewsData
}

const NewsList = ({ data }: Props) => (
  <Wrapper space="l">
    <TitleWithBorder>Другие новости</TitleWithBorder>
    <div className="news-list">
      {data.items.map((article, index) => (
        <NewsItem key={index} {...article} />
      ))}
    </div>
  </Wrapper>
)

export default NewsList
